"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeadlineStyles3 = exports.HeadlineStyles2 = exports.HeadlineStyles1 = exports.Line5Styles = exports.Line4Styles = exports.Line3Styles = exports.Line2Styles = exports.Line1Styles = exports.ShowMd = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _uiKit = require("@dbi-tools/ui-kit");

var _helpers = require("./helpers");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ShowMd = /*#__PURE__*/(0, _styledComponents.default)("div").withConfig({
  displayName: "styled__ShowMd",
  componentId: "vg1t87-0"
})(["display:none;", "{display:block;}"], _uiKit.GridBreakpointsMediaDown.lg);
exports.ShowMd = ShowMd;
var Line1Styles = /*#__PURE__*/(0, _styledComponents.css)(["", " ", ";"], function (_ref) {
  var $styles = _ref.theme.$styles;
  return $styles ? (0, _helpers.lineStyles)({
    styles: $styles,
    line: 'line1'
  }) : '';
}, function (_ref2) {
  var color = _ref2.color;
  return color && "color: ".concat(_uiKit.Colors[color]);
});
exports.Line1Styles = Line1Styles;
var Line2Styles = /*#__PURE__*/(0, _styledComponents.css)(["", " ", ";"], function (_ref3) {
  var $styles = _ref3.theme.$styles;
  return $styles ? (0, _helpers.lineStyles)({
    styles: $styles,
    line: 'line2'
  }) : '';
}, function (_ref4) {
  var color = _ref4.color;
  return color && "color: ".concat(_uiKit.Colors[color]);
});
exports.Line2Styles = Line2Styles;
var Line3Styles = /*#__PURE__*/(0, _styledComponents.css)(["", " ", ";"], function (_ref5) {
  var $styles = _ref5.theme.$styles;
  return $styles ? (0, _helpers.lineStyles)({
    styles: $styles,
    line: 'line3'
  }) : '';
}, function (_ref6) {
  var color = _ref6.color;
  return color && "color: ".concat(_uiKit.Colors[color]);
});
exports.Line3Styles = Line3Styles;
var Line4Styles = /*#__PURE__*/(0, _styledComponents.css)(["", " ", ";"], function (_ref7) {
  var $styles = _ref7.theme.$styles;
  return $styles ? (0, _helpers.lineStyles)({
    styles: $styles,
    line: 'line4'
  }) : '';
}, function (_ref8) {
  var color = _ref8.color;
  return color && "color: ".concat(_uiKit.Colors[color]);
});
exports.Line4Styles = Line4Styles;
var Line5Styles = /*#__PURE__*/(0, _styledComponents.css)(["", " ", ";"], function (_ref9) {
  var $styles = _ref9.theme.$styles;
  return $styles ? (0, _helpers.lineStyles)({
    styles: $styles,
    line: 'line5'
  }) : '';
}, function (_ref10) {
  var color = _ref10.color;
  return color && "color: ".concat(_uiKit.Colors[color]);
});
exports.Line5Styles = Line5Styles;
var HeadlineStyles1 = /*#__PURE__*/(0, _styledComponents.css)(["", " ", ";"], function (_ref11) {
  var $styles = _ref11.theme.$styles;
  return $styles ? (0, _helpers.lineStyles)({
    styles: $styles,
    line: 'headline1'
  }) : '';
}, function (_ref12) {
  var color = _ref12.color;
  return color && "color: ".concat(_uiKit.Colors[color]);
});
exports.HeadlineStyles1 = HeadlineStyles1;
var HeadlineStyles2 = /*#__PURE__*/(0, _styledComponents.css)(["", " ", ";"], function (_ref13) {
  var $styles = _ref13.theme.$styles;
  return $styles ? (0, _helpers.lineStyles)({
    styles: $styles,
    line: 'headline2'
  }) : '';
}, function (_ref14) {
  var color = _ref14.color;
  return color && "color: ".concat(_uiKit.Colors[color]);
});
exports.HeadlineStyles2 = HeadlineStyles2;
var HeadlineStyles3 = /*#__PURE__*/(0, _styledComponents.css)(["", " ", ";"], function (_ref15) {
  var $styles = _ref15.theme.$styles;
  return $styles ? (0, _helpers.lineStyles)({
    styles: $styles,
    line: 'headline3'
  }) : '';
}, function (_ref16) {
  var color = _ref16.color;
  return color && "color: ".concat(_uiKit.Colors[color]);
});
exports.HeadlineStyles3 = HeadlineStyles3;